import React, { useEffect, useRef } from "react";
import { useIngressesAndUploads } from "./lib/useIngressesAndUploads";
import { UploadStatus } from "lib/types/UploadStatus";
import UploadCompleteSvg from "components/icons/UploadIcons/upload-complete.svg";
import ProcessingStepSvg from "components/icons/UploadIcons/processing-step.svg";
import UploadingStepSvg from "components/icons/UploadIcons/uploading-step.svg";
import IngressJobsDropdown from "./IngressJobsDropdown";
import HeaderPopover, { HeaderPopoverRef } from "../HeaderPopover";

type SpinnerStatus =
  | "hidden"
  | "uploading"
  | "processing"
  | "complete"
  | undefined;

export default function IngressJobsButton() {
  const popoverRef = useRef<HeaderPopoverRef>(null);
  const { ingressesAndUploads } = useIngressesAndUploads();

  const count = ingressesAndUploads.length;
  const countUploading = ingressesAndUploads.filter(
    (x) => x.uploadStatus !== UploadStatus.complete && x.uploadStatus !== null,
  ).length;
  const countProcessing = ingressesAndUploads.filter(
    (x) =>
      x.ingressStatus === "processing" ||
      x.ingressStatus === "awaitingProcessing",
  ).length;
  const countDone = ingressesAndUploads.filter(
    (x) =>
      x.ingressStatus === "done" ||
      x.ingressStatus === "error" ||
      x.ingressStatus === "partialError",
  ).length;

  let spinnerStatus: SpinnerStatus;
  if (count == 0) spinnerStatus = "hidden";
  else if (countUploading > 0) spinnerStatus = "uploading";
  else if (countProcessing > 0) spinnerStatus = "processing";
  else if (countDone > 0) spinnerStatus = "complete";

  useEffect(() => {
    if (spinnerStatus === "uploading") popoverRef.current?.open();
  }, [spinnerStatus]);

  return (
    <>
      {spinnerStatus !== "hidden" && (
        <HeaderPopover
          ref={popoverRef}
          buttonContent={<IngressJobsHeaderIcon status={spinnerStatus} />}
        >
          <IngressJobsDropdown />
        </HeaderPopover>
      )}
    </>
  );
}

const IngressJobsHeaderIcon = (p: { status?: SpinnerStatus }) => {
  if (p.status === "hidden") return null;
  return (
    <>
      {p.status === "uploading" && (
        <UploadingStepSvg className="h-full w-6 text-gray-500" />
      )}
      {p.status === "processing" && (
        <ProcessingStepSvg className="h-full w-6 " />
      )}
      {p.status === "complete" && (
        <UploadCompleteSvg className="w-8 text-gray-500" />
      )}
    </>
  );
};
